import { Action } from '../actions/marketing';

const defaultState = {
  isFetching: false,
  savedByUsers: {},
  platformTotals: [],
  requestSYWInfoError: undefined,
  requestedSYWInfo: false,
};

export default function marketingReducer(state = defaultState, action) {
  switch (action?.type) {
    case Action.Pay.RequestSYWInfoComplete:
      return {
        ...state,
        requestedSYWInfo: true,
        requestSYWInfoError: undefined,
      };

    case Action.Pay.RequestSYWInfoFailed:
      return {
        ...state,
        requestedSYWInfo: true,
        requestSYWInfoError: action.payload,
      };

    default:
      return state;
  }
}
